<template>
  <iColumn gap="standard" width="fill">
    <iRow
      v-for="(entry, entryIndex) in entries"
      :key="entryIndex"
      gap="standard"
      vertical-align="middle"
      wrap="nowrap"
      width="fill"
    >
      <label class="color-swatch-label" :style="swatchStyle(entry)">
        <input
          type="color"
          class="color-swatch-input"
          :value="normalizeHex(entry)"
          @input="updateEntry(entryIndex, $event.target.value)"
        >
      </label>
      <iColumn width="fill">
        <iTextInput
          :model-value="entry"
          :placeholder="field.placeholder || '#000000'"
          width="fill"
          @update:model-value="updateEntry(entryIndex, $event)"
        />
      </iColumn>
      <iButton
        v-if="entries.length > 1"
        variant="tertiary"
        size="small"
        width="hug"
        @click="removeEntry(entryIndex)"
      >
        Remove
      </iButton>
    </iRow>

    <iButton
      variant="secondary"
      width="fill"
      @click="addEntry"
    >
      {{ addLabel }}
    </iButton>
  </iColumn>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useQuestionnaireStore } from "@/stores/questionnaire-store";

const HEX_PATTERN = /^#[0-9a-fA-F]{6}$/;
const DEFAULT_HEX = "#000000";

export default {
  name: "QuestionnaireColorPickerList",
  props: {
    sectionKey: {
      type: String,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useQuestionnaireStore, ["responseData"]),
    entries() {
      const list = this.responseData[this.sectionKey][this.field.key];
      return Array.isArray(list) ? list : [];
    },
    addLabel() {
      return this.field.repeater_add_label || "+ Add another color";
    },
  },
  methods: {
    ...mapActions(useQuestionnaireStore, [
      "addRepeaterEntry",
      "removeRepeaterEntry",
      "setRepeaterEntryValue",
    ]),
    normalizeHex(value) {
      if (typeof value === "string" && HEX_PATTERN.test(value.trim())) {
        return value.trim();
      }
      return DEFAULT_HEX;
    },
    // Empty entries preview as black (matching the picker's default) rather
    // than showing the grey card/border through a transparent swatch. This is
    // display only - the text input stays empty until the user picks a color.
    swatchStyle(value) {
      const hex = HEX_PATTERN.test((value || "").trim()) ? value.trim() : DEFAULT_HEX;
      return { backgroundColor: hex };
    },
    updateEntry(entryIndex, newValue) {
      this.setRepeaterEntryValue(this.sectionKey, this.field.key, entryIndex, newValue);
    },
    addEntry() {
      this.addRepeaterEntry(this.sectionKey, this.field.key);
    },
    removeEntry(entryIndex) {
      this.removeRepeaterEntry(this.sectionKey, this.field.key, entryIndex);
    },
  },
};
</script>

<style scoped lang="scss">
.color-swatch-label {
    display: inline-flex;
    width: 44px;
    height: 44px;
    border-radius: 8px;
    border: 1px solid var(--i-color-border, #d9d9d9);
    cursor: pointer;
    overflow: hidden;
    flex-shrink: 0;
}

.color-swatch-input {
    width: 100%;
    height: 100%;
    border: 0;
    padding: 0;
    background: transparent;
    cursor: pointer;
    opacity: 0;
}
</style>
